enum DistanceUnit {
  KILOMETER = 'km',
  METER = 'm',
  MILE = 'mi',
  FOOT = 'ft',
}

export default DistanceUnit;
